import clsx from 'clsx'
import React from 'react'

export enum Sizes {
  xs = 'xs',
  sm = 'sm',
  base = 'base',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  '2xl' = '2xl',
  '3xl' = '3xl',
  '4xl' = '4xl',
  '5xl' = '5xl'
}

type Props = {
  isFullPage?: boolean
  isParentSized?: boolean
  loading?: boolean
  width?: number
  height?: number
  size?: Sizes
}

const sizeToPixels: Record<Sizes, number> = {
  [Sizes.xs]: 20,
  [Sizes.sm]: 30,
  [Sizes.base]: 40,
  [Sizes.md]: 50,
  [Sizes.lg]: 60,
  [Sizes.xl]: 80,
  [Sizes['2xl']]: 96,
  [Sizes['3xl']]: 112,
  [Sizes['4xl']]: 128,
  [Sizes['5xl']]: 144,
}

const Loading: React.FC<Props> = ({
  isFullPage = false,
  isParentSized,
  loading,
  width,
  height,
  size = Sizes.xl,
}) => {
  if (!loading) return null

  const resolvedWidth = width ?? sizeToPixels[size]
  const resolvedHeight = height ?? sizeToPixels[size]

  return (
    <div
      className={clsx(
        'flex items-center justify-center pointer-events-auto',
        {
          'fixed inset-0 z-50 bg-white/50 backdrop-blur-sm': isFullPage,
          'absolute inset-0 z-30 bg-white/50 backdrop-blur-sm': isParentSized,
          'w-max z-40': !isFullPage && !isParentSized,
        }
      )}
    >
      <svg
        version="1.1"
        id="L9"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        xmlSpace="preserve"
        width={resolvedWidth}
        height={resolvedHeight}
        className="fill-primary"
      >
        <path
          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  )
}

export default Loading
